import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface Shift {
  id: number;
  start: string;
  end: string;
  color?: string;
  name?: string;
}

@Component({
  selector: 'app-modal-turnos',
  templateUrl: './modal-turnos.component.html',
  styleUrls: ['./modal-turnos.component.scss']
})
export class ModalTurnosComponent implements OnInit {

  @Input() turnos: Shift[] = [];
  @Input() title: string = 'Seleccionar turno';

  selectedShift: Shift | null = null;

  constructor(public activeModal: NgbActiveModal) {}

  selectShift(shift: Shift): void {
    this.selectedShift = shift;

  }

  ngOnInit(){
    console.log(this.turnos)
  }

confirm(): void {
  if (!this.selectedShift) return;
  this.activeModal.close(this.selectedShift);
}

  cancel(): void {
    this.activeModal.dismiss();
  }
}
